var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/trush-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trush-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M16.1898 2.5H7.81978C4.17978 2.5 2.00977 4.67 2.00977 8.31V16.68C2.00977 20.32 4.17978 22.49 7.81978 22.49H16.1898C19.8298 22.49 21.9998 20.32 21.9998 16.68V8.31C21.9998 4.67 19.8298 2.5 16.1898 2.5Z",
    fill: "#314DDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8598 8.96008C16.0198 8.88008 15.2498 8.83008 14.4998 8.78008L14.4198 8.30008C14.3498 7.82008 14.1998 6.83008 12.6898 6.83008H11.2998C9.80979 6.83008 9.6498 7.78008 9.5698 8.29008L9.4898 8.76007C9.0598 8.79007 8.6398 8.81007 8.2098 8.85007L7.11979 8.96008C6.73979 9.00008 6.46979 9.33008 6.50979 9.71008C6.54979 10.0601 6.83979 10.3301 7.18979 10.3301C7.20979 10.3301 7.23979 10.3301 7.25979 10.3301L8.33979 10.2201C8.93979 10.1701 9.54979 10.1201 10.1498 10.0901C11.3698 10.0401 12.5898 10.0601 13.8198 10.1201C14.7298 10.1601 15.6798 10.2301 16.7198 10.3301C16.7398 10.3301 16.7598 10.3301 16.7798 10.3301C17.1298 10.3301 17.4298 10.0601 17.4598 9.71008C17.5098 9.33008 17.2398 8.99008 16.8598 8.96008Z",
    fill: "#314DDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.83 11.6001C15.66 11.4101 15.41 11.3101 15.16 11.3101H8.84C8.59 11.3101 8.34 11.4201 8.17 11.6001C8 11.7901 7.91 12.0401 7.93 12.2901L8.24001 16.2501C8.30001 17.1001 8.37 18.1601 10.29 18.1601H13.71C15.63 18.1601 15.7 17.1001 15.76 16.2501L16.07 12.2901C16.09 12.0401 16 11.7901 15.83 11.6001Z",
    fill: "#314DDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.678cfbf76adfa5254ef2aae9f6a3acb2.svg";
export { ForwardRef as ReactComponent };